import { appHttpClient } from "../../../../installations/http/axiosInterfaces";
import { dedupeRequest } from "../../../../installations/http/inFlight";

// Get Item Groups
export const getItemGroups = (queryParams) => {
  // 0016: dedupe StrictMode double-invoke (the useItemGroupsQuery queryFn AND the AdminCatalog thunk
  // path) into one network request. Key on the params so different page sizes fetch independently.
  return dedupeRequest(`itemGroups:${JSON.stringify(queryParams || {})}`, () =>
    appHttpClient.get(`/ItemGroup/List`, { params: queryParams })
  );
};

// Connect Item Group with Category
export const connectItemGroupWithCategory = (categoryId, itemGroupId) => {
  return appHttpClient.post(`/ItemGroup/Category/Connect/${categoryId}/${itemGroupId}`);
};

// Disconnect Item Group from Category
export const disconnectItemGroupFromCategory = (categoryId, itemGroupId) => {
  return appHttpClient.post(`/ItemGroup/Category/Disconnect/${categoryId}/${itemGroupId}`);
};

export const updateDisplayOrder = (categoryId, itemGroupId) => {
  return appHttpClient.post(`/ItemGroup/Update/DisplayOrder/${categoryId}/${itemGroupId}`);
};

const itemGroupsService = {
  getItemGroups,
  connectItemGroupWithCategory,
  disconnectItemGroupFromCategory,
  updateDisplayOrder,
};

export default itemGroupsService;
